import React from "react";
import adobe from "../../../../../assets/images/AdobeStock.jpg"

export default function FinancialDescription() {
  return (
    <section>
      <div className="">
        {/* top description */}
        <div className="flex flex-col py-8 mt-6 md:mt-14 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0"
            />
          </div>

          {/* right text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 md:py-10 w-full">
            <div className="text-xl font-semibold text-black mx-auto  md:text-left">
              Purpose-built IT solutions for banks, lenders and financial
              services firms, designed to keep sensitive data secure and
              systems compliant.
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-lg space-y-5 md:space-y-10">
              <p className="leading-7">
                From core banking infrastructure to customer-facing digital
                services, we help financial organisations run resilient,
                secure and compliant IT environments.{" "}
              </p>

              <p className="leading-7">
                Our team understands the regulatory landscape financial
                businesses operate in, and builds solutions that satisfy FCA,
                PCI DSS and GDPR requirements while keeping your operations
                fast and reliable.
              </p>
            </div>
          </div>
        </div>

        {/* middle description */}
        <div className="flex flex-col py-5 md:py-8 mt-3 md:mt-10 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full md:hidden  mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full md:hidden shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>

          {/* left text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 md:py-10 w-full">
            <div className="text-3xl font-bold text-black mx-auto  md:text-left">
              Secure banking &amp; financial technology
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-xl space-y-5 md:space-y-10">
              <p className="leading-7">
                We deliver secure transaction processing, encrypted data
                storage and hardened network infrastructure designed
                specifically for the risk profile of financial institutions.{" "}
              </p>

              <p className="leading-7">
                Whether you need support for legacy banking systems or a
                migration to modern fintech platforms, our solutions are
                tailored to your compliance obligations and business
                requirements.
              </p>
              <p className="leading-7">
                Every engagement includes ongoing monitoring and support, so
                your financial systems stay protected and available around
                the clock.
              </p>
            </div>
          </div>

          {/* image section */}
          <div className="w-full mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full hidden md:block shadow-lg rounded h-full   md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>
        </div>

        {/* last description */}
        <div className="flex flex-col bg-slate-100 py-6 md:py-12 mt-10 md:mt-20 px-6 md:flex-row md:space-x-16 md:px-10 xl:px-16">
          {/* image section */}
          <div className="w-full  mx-auto md:-mt-0 ">
            <img
              alt=""
              src={adobe}
              className="w-full shadow-lg rounded h-full md:mb-0 object-center object-cover md:inset-0 "
            />
          </div>

          {/* right text */}
          <div className="flex-col mt-10 md:mt-0 space-y-5 md:space-y-10 py-5 md:py-10 w-full">
            <div className="text-3xl font-bold text-black mx-auto  md:text-left">
              Trusted by the financial sector
            </div>

            {/* text */}
            <div className="text-left text-gray-600 text-xl space-y-5 md:space-y-10">
              <p className="leading-7 font-semibold text-black text-xl">
                At TPS we work closely with banks and financial services
                clients, ensuring their IT systems meet the highest standards
                of security and regulatory compliance.{" "}
              </p>

              <p className="leading-7">
                TPS have been industry leaders for more than 10 years and have
                worked closely with numerous organisations helping them grow
                and develop as well as keeping their data and IT network safe.
              </p>
              <p className="leading-7">
                It's important for us that our clients' businesses are running
                24/7 and we do all within our power to prevent downtime, but
                should the worst happen we get the systems up and running as
                quickly as possible. We put our customers first, consistently
                delivering fast response times and a high standard of
                resolution our clients can rely on.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
